import { useState } from "react";

export const CreditPackUI =({p,toggle,save})=>{
    const [packName, setPackName] =useState(p.packName)
    let [credits, setCredits] =useState(p.credits)
    let [amountPaise, setAmountPaise] =useState(p.amountPaise)
    const [isActive, setIsActive] =useState(p.isActive)

    
function StatusBadge({ active }) {
  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 600,
        background: active ? "#10b98120" : "#ef444420",
        color: active ? "#10b981" : "#ef4444"
      }}
    >
      {active ? "Active" : "Inactive"}
    </span>
  );
}
    return(<><tr key={p.id}>
                <td style={{ textTransform: "capitalize" }}>
                  {p.channel}
                </td>

                <td>
                  <input
                    style={styles.input}
                    value={packName}
                    onChange={e => setPackName(e.target.value)}
                  />
                </td>

                <td>
                  <input
                    type="number"
                    style={styles.input}
                    value={credits}
                    onChange={e =>
                      (   setCredits(credits =+e.target.value) )
                    }
                  />
                </td>

                <td>
                  <input
                    type="number"
                    style={styles.input}
                    value={amountPaise}
                    onChange={e =>
                      (   setAmountPaise(amountPaise = +e.target.value))
                    }
                  />
                </td>

                <td>
                  <StatusBadge
                    active={isActive === "true"}
                  />
                </td>

                <td style={styles.actions}>
                  <button
                    style={styles.saveBtn}
                    onClick={() =>{
                     
                        save({id:p.id,packName:packName,credits:credits,amountPaise,isActive})

                    } }
                  >
                    Save
                  </button>

                  <button
                    style={styles.toggleBtn}
                    onClick={() => {toggle({id:p.id,isActive})
                setIsActive(isActive === "true"?"false":"true")}}
                  >
                    {isActive === "true"
                      ? "Disable"
                      : "Enable"}
                  </button>
                </td>
              </tr></>)
}

const styles = {
  wrapper: {
    padding: 30,
    background: "#f8fafc",
   
    fontFamily: "Inter, sans-serif"
  },

  heading: {
    marginBottom: 20,
    fontSize: 22,
    fontWeight: 700
  },

  tableWrapper: {
    overflowX: "auto",
    background: "#ffffff",
    borderRadius: 14,
    boxShadow: "0 6px 25px rgba(0,0,0,0.05)"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 800
  },

  input: {
    padding: "6px 8px",
    borderRadius: 6,
    border: "1px solid #e5e7eb",
    width: "100%"
  },

  actions: {
    display: "flex",
    gap: 8
  },

  saveBtn: {
    padding: "6px 12px",
    borderRadius: 8,
    border: "none",
    background: "#4f46e5",
    color: "#fff",
    cursor: "pointer",
    fontWeight: 600
  },

  toggleBtn: {
    padding: "6px 12px",
    borderRadius: 8,
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer"
  }
};